import { useSelector } from 'react-redux'
import PageTabMenu from './PageTabMenu'


const PageTabActionMenu = () => {
  const tabItems = useSelector((state) => state.dynamicUi.pages.tabs.data)

  //can pin only when tab has more than 1 item. We are checking for 2 because "Adding new" also comprises 1 tab
  const showPinnedWhen = tabItems && tabItems.length > 1

  //can change orientation only when there is no tabs to prevent tab data consistency
  const showChangeOrientationWhen = !tabItems?.length || tabItems.length === 1


  return (
    <div className="flex space-x-2">
      {showChangeOrientationWhen && <PageTabMenu isPinType={false}/>}

      {showPinnedWhen && <PageTabMenu />}

    </div>

  )
}

export default PageTabActionMenu
